import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const TakingCarPurchaseStore = WithErrorBoundary(
  'Stock',
  'Error en Taking car Management de stock',
  React.lazy(() => import('./TakingCarPurchase.store')),
)

export default {
  path: '/compra-de-usados',
  name: 'Compra de usados',
  childRoutes: [
    { path: '', name: 'Compra de usados', component: TakingCarPurchaseStore, isIndex: true },
  ],
};